import { createSelector } from 'reselect';
import { IRootState } from 'store';
import { IEventsState } from 'types';

export const eventSelector = (state: IRootState): IEventsState => state.events;

export const createEventErrorsSelector = createSelector(
  eventSelector,
  (events) => events.errors
);
